<template>
  <div class="container">
    This is residents profile view
  </div>
</template>

<script>

export default {
    name: 'residents'
};
</script>

<style lang="scss" scoped>

</style>
